<template>
  <div class="animated fadeIn">
    <b-card border-variant="border">
      <div slot="header">
        <strong>User Information</strong>
        <span class="pull-right" v-if="!add && model.created_at">Created_at ({{model.created_at | sdate}} @ {{model.last_addr || '-'}})</span>
      </div>
      <b-row>
        <b-col md="3">
          <b-form-group label="Allow login" label-for="ph_use"
            v-b-tooltip.hover title="Allow login.">
            <c-switch color="info" label size="sm" v-model="model.is_alive" :disabled="lock" />
          </b-form-group>
        </b-col>
        <!-- <b-col md="3">
          <b-form-group label="Email verified" label-for="ph_active"
            v-b-tooltip.hover title="Email verified.">
            <c-switch color="info" label size="sm" v-model="model.is_verified" :disabled="lock" />
          </b-form-group>
        </b-col> -->
        <b-col md="6" v-if="model.id">
          <b-form-group>
            <label>Last_visit</label>
            <b-form-input type="text" :value="model.last_visit | datetime" plaintext></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group>
            <label for="ph_group" v-b-tooltip.hover title="Permission.">Permission(*)</label>
            <v-select v-if="!lock" label="name" v-model="model.permissions" :options="codes.permissions_user"></v-select>
            <b-form-input type="text" v-if="lock" :value="model.permissions" plaintext></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <label for="ph_nickname">Nickname(*)</label>
            <b-form-input type="text" id="ph_nickname" v-model="model.nickname" :plaintext="lock"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-form-group>
            <label for="ph_username" v-b-tooltip.hover title="The username recommended E-mail address. we default notice by email">Username(ID)(*)</label>
            <b-form-input @change="set_nickname" type="text" id="ph_username" v-model="model.username" :plaintext="lock"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="add || !lock">
        <b-col md="6">
          <b-form-group>
            <label for="ph_pass">{{add ? 'User' : 'Change'}} Password(*)</label>
            <b-form-input type="password" id="ph_pass" v-model="model.new_password" :plaintext="lock"></b-form-input>
            <b-badge v-if="model.new_password"  :variant="password_policy('number') ? 'success' : 'danger'"> Number </b-badge>
            <b-badge v-if="model.new_password"  :variant="password_policy('uppercase') ? 'success' : 'danger'"> Upper Characters </b-badge>
            <b-badge v-if="model.new_password"  :variant="password_policy('lowercase') ? 'success' : 'danger'"> Lower Characters </b-badge>
            <b-badge v-if="model.new_password"  :variant="password_policy('spacial') ? 'success' : 'danger'"> Special Characters </b-badge>
            <b-badge v-if="model.new_password"  :variant="password_policy('length') ? 'success' : 'danger'">
              Min Length : 10
            </b-badge>
          </b-form-group>
        </b-col>
        <b-col md="6" v-if="model.new_password">
          <b-form-group>
            <label for="ph_pass2">Password Repeat(*)</label>
            <b-form-input type="password" id="ph_pass2" v-model="model.new_password_repeat"  :plaintext="lock"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-button v-if="!lock" size="sm" variant="success" @click="save"> Save </b-button>
      <b-button v-else size="sm" variant="warning" @click="lock = false"> Edit </b-button>
      <b-button v-if="!lock" size="sm" variant="info" @click="cancel"> Cancel </b-button>
      <b-button size="sm" variant="danger" @click="confirm = true;" v-if="model.id"> Remove </b-button>
      <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
      <!-- TODO -->
      <!-- <b-row>
        <b-col md="6">
          <b-form-group>
            <label for="ph_group" v-b-tooltip.hover title="Enter a single IP or network range, etc) 192.168.0.100, 192.168.0.0/24 ">List of allowed IPs</label>
            <b-form-textarea v-model="model.restrict_addr" :plaintext="lock"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row> -->
      <!-- start group info -->
      <hr>
      <strong>Group(*)</strong>
      <span class="pull-right" v-if="model.group">{{model.group.last_visit | sdate}}@{{model.group.last_addr || '-'}}</span>
      <b-button v-if="!lock && !model.group.id" variant="warning" @click="chainGroup = true" :disabled="loadGroup">
        {{model.group.id ? 'Change' : 'Connect'}} Group
      </b-button>
      <b-button v-if="$route.params.id != 'add' && syncGroup && lock" variant="success" @click="GroupSave()"> apply </b-button>
      <hr>
      <b-row v-if="model.group.id">
        <b-col md="12">
          <b-form-group>
            <label for="ph_name">Group Name</label>
            <b-form-input md=12 type="text" id="ph_name" v-model="model.group.groupname" :disabled="true"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="model.group.id">
        <b-col md="6">
          <b-form-group>
            <label for="ph_service" v-b-tooltip.hover title="Service">Service</label>
            <v-select v-if="add" :disabled="true" label="name" v-model="model.group.service" :options="codes.service"></v-select>
            <h4 v-else>
              <b-badge  :variant="model.group.service == 'Basic' ? 'info' : 'success'"> {{model.group.service}} </b-badge>
            </h4>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Verified" label-for="ph_use"
            v-b-tooltip.hover title="Verified Allow login.">
            <c-switch color="info" label size="sm" v-model="model.group.is_verified" :disabled="true" />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Member's" label-for="ph_count"
            v-b-tooltip.hover title="Verified Allow login.">
            {{model.group.Count || 0}}
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="model.group.id">
        <b-col md="4">
          <b-form-group label="country" label-for="ph_country" v-b-tooltip.hover title="country.">
            <v-select :readonly="true" @input="set_country" :disabled="lock" label="name" v-model="region.country" :options="codes.country" ></v-select>
            <!-- <b-form-input type="text" id="ph_country" v-model="region.country" :disabled="true"></b-form-input> -->
          </b-form-group>
        </b-col>
        <b-col md="4">
          <label for="ph_language_group" v-b-tooltip.hover title="language">language(*)</label>
          <v-select :readonly="true" @input="set_language" :disabled="lock" label="name" v-model="region.language" :options="codes.language"></v-select>
          <!-- <b-form-group label="language" label-for="ph_language" v-b-tooltip.hover title="language.">
            <b-form-input type="text" id="ph_language" v-model="region.language" :disabled="true"></b-form-input> -->
          <!-- </b-form-group> -->
        </b-col>
        <b-col md="4">
          <label for="ph_timezone_group" v-b-tooltip.hover title="Timezone">Timezone(*)</label>
          <v-select :readonly="true" @input="set_timezone" :disabled="lock" label="name" v-model="region.timezone" :options="codes.timezone" ></v-select>
        </b-col>
      </b-row>
      <b-row v-if="model.group.id">
        <b-col md="6">
          <b-form-group>
            <label for="ph_email" v-b-tooltip.hover title="Email">E-mail</label>
            <b-form-input type="text" id="ph_email" :value="model.group.email" v-model="model.group.email" :disabled="true"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="contact" label-for="ph_contact" v-b-tooltip.hover title="contact.">
            <b-form-input type="text" id="ph_contact" :value="model.group.contact" v-model="model.group.contact" :disabled="true"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="model.group.id">
        <b-col md="12">
          <b-form-group>
            <label for="ph_address">Address</label>
            <b-form-input md=12 type="text" id="ph_address" v-model="model.group.address" :disabled="true"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- end group info -->
      <template>
        <b-button v-if="!add" size="sm" class="pull-right mx-1" variant="info" @click="groupList"> Group Detail </b-button>
      </template>
    </b-card>
    <log-Login-List v-if="model.id" :user="model"></log-Login-List>
    <b-modal title="User Remove"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      Are you sure you want to delete this user?
    </b-modal>
    <!-- start connect group modal -->
    <b-modal title="Find then Group and Select" size="lg"  class="modal-info" v-model="chainGroup" @ok="chainGroup = false" ok-variant="info">
      <group-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></group-List>
    </b-modal>
    <!-- end connect group modal -->
  </div>
</template>

<script>
import { Api, auth } from '@/service';
import codes from '@/codes';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import * as forge from 'node-forge'
import reg from '@/reg'

// another vue
import groupList from '../group/Group.List'
import logLoginList from '../../Log/login/Login.List.User'

const default_model = () => ({
  is_verified: true, group : { service : "Basic" }, permissions: 'User', username : '', new_password : '', new_password_repeat : '',
});

export default {
  components: {
    cSwitch,
    vSelect,
    groupList,
    logLoginList,
  },
  watch : { '$route' (to, from) { this.get(to.params, from); }, },
  data : () => ({
    codes,
    confirm: false,
    add: false,
    lock: true,
    group_list: undefined,
    model : default_model(),
    old_username : '',
    allowed: false,

    // group info side
    chainGroup : false,
    syncGroup : false,
    loadGroup : false,
    region : {
      language : codes.language_default,
      country : codes.country_default,
      timezone : codes.timezone_default
    },
    password_meter : { is_spacial : false, is_alphabat_upper : false, is_alphabat_lower : false, is_number : false, check_length : false  },
    origin : { timezone : "", country : "", language : "" },

  }),
  computed: {
    border() { return !reg.email.test(this.model.username) || this.model.title == '' ? 'danger' : 'success'},
    TextLength() { return this.model.username.length > 0 ? true : false; },
    profile() { return auth.profile; }
  },
  methods: {
    set_nickname(username) {
      this.model = Object.assign({}, this.model)
      if(!this.model.nickname) { this.model.nickname = username.split("@").length > 1 ? username.split("@")[1] : '' }
    },
    password_policy(type = '')
    {
      switch (type) {
        case 'number':
          this.password_meter.is_number = this.model.new_password && reg.reg_number.test(this.model.new_password) ? true : false;
          return this.password_meter.is_number;
        case 'uppercase':
          this.password_meter.is_alphabat_upper = this.model.new_password && reg.reg_alphabat_upper.test(this.model.new_password) ? true : false;
          return this.password_meter.is_alphabat_upper;
        case 'lowercase':
          this.password_meter.is_alphabat_lower = this.model.new_password && reg.reg_alphabat_lower.test(this.model.new_password) ? true : false;
          return this.password_meter.is_alphabat_lower;
        case 'spacial':
          this.password_meter.is_spacial = this.model.new_password && reg.reg_spacial.test(this.model.new_password) ? true : false;
          return this.password_meter.is_spacial;
        case 'length':
          this.password_meter.check_length = (this.model.new_password && this.model.new_password.length >= 10) ? true : false
          return this.password_meter.check_length;
        // eslint-disable-next-line no-case-declarations
        case 'all':
          let keys = Object.keys(this.password_meter);
          for (let i = 0; i < keys.length; i++) {
            // if has can't pass
            if(!this.password_meter[keys[i]]) { return { is_error : true, key : keys[i] }; }
          }
          // all pass
          return { is_error : false };
        default:
          return false;
      }
    },
    cancel() { this.lock = true; this.$router.push({ name: 'group', }); this.$emit('refresh'); },
    edit() { this.$router.push({ name: 'user', params: { id: this.model.id, tag: 'edit' }}); },
    async remove() {
      try {
        let rs = await Api.Partner_Call('user', 'delete', { id : this.model.id });
        if(!rs.error) {
          this.$emit('refresh'); this.$toastr.s('Removed Success.'); this.list();
        } else {
          this.$emit('refresh'); this.$toastr.s('delete', "failed"); this.list();
        }

      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list(); }
    },
    list() { this.$router.push({ name: 'group', params : { id : this.model.group_id }}); this.$emit('refresh'); },
    set_country:function(x) { if(!x) { return; } this.model.country = x.value },
    set_timezone:function(x) { if(!x) { return; } this.model.timezone = x.value },
    set_language:function(x) { if(!x) { return; } this.model.language = x.value },
    setGroup(item) {
      this.model.group = item;
      if(!item.service) { this.model.group.service = this.model.service } // set default
      this.chainGroup = false;
      this.syncGroup = true;
    },
    groupList() { this.$router.push({ name: 'group', params : { id : this.model.group_id }}); this.$emit('refresh'); },
    refresh() {
      this.$emit('refresh');
      console.log("refresh", this.$route.name, new Date());
    },
    async GroupSave() {
      try {
        this.model.group_id = this.model.group.id;
        let rs = await Api.Partner_Call('user', 'update', this.model);
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
        } else {
          this.$toastr.e('Save', "failed");
        }
        this.syncGroup = false;
        this.refresh();
      } catch (e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText); }
    },
    async save() {
      let model = {};

      // check validation
      try {
        if(!(this.model.permissions || '').trim()) { return this.$toastr.e('Permission Required.'); }
        if(!(this.model.username || '').trim()) { return this.$toastr.e('Username(ID) Required.'); }
        if(!(this.model.nickname || '').trim()) { return this.$toastr.e('Nickname Required.'); }
        // if(!this.model.id && !this.model.new_password) { return this.$toastr.e('Password Required.'); }
        if(this.model.new_password && this.model.new_password != this.model.new_password_repeat) { return this.$toastr.e('Password and password reoeat do not match'); }
        if(this.model.new_password) {
          var rs = this.password_policy('all')
          if(rs.is_error) {
            var msg = rs.key.indexOf('is') > -1 ? rs.key.substring(3) : rs.key;
            return this.$toastr.e(`Please check password policy [${msg}]`);
          }
        }
      } catch (e) { console.log(e); return this.$toastr.e('check validation failed'); }


      // build data for sending
      model = Object.assign({}, this.model, { permissions : codes.permissions_user_value[this.model.permissions] })
      if(model.new_password) { model.new_password = forge.sha256.create().update(model.new_password).digest().toHex(); }
      if(model.group && model.group.id) { model.group_id = model.group.id; }

      let region = {};
      region.country = this.region.country.value
      region.language = this.region.language.value
      region.timezone = this.region.timezone.value

      try {
        let rs = await Api.Partner_Call('user', model.id ? 'update' : 'insert', Object.assign({}, model, region));
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name); this.cancel();
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }

      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText) }
      this.lock = true;
    },
    async get({ id, tag } = this.$route.params) {
      this.model = default_model()
      if(tag == 'group') {
        try {
          console.log('User.detail.vue', 'group item', id);
          this.loadGroup = true;
          let rs = await Api.Partner_Call('group', 'detail', { id : id })
          if(rs.error) { return this.$toastr.e("group load failed") }

          this.model.group = Object.assign({ group: {} }, this.model.group, rs.body)
          this.model.group_id = this.model.group.id;

          this.loadGroup = false;

          let is_done_country = false;
          codes.country.forEach(r => { if(is_done_country || !this.model.group.country) { return; } else if(r.value == this.model.group.country.toUpperCase()) { this.region.country = r; is_done_country = true } });

          let is_done_language = false;
          codes.language.forEach(r => { if(is_done_language || !this.model.group.language) { return; } else if(r.value == this.model.group.language.toUpperCase()) { this.region.language = r; is_done_language = true } });

          let is_done_timezone = false;
          codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(r.value == this.model.group.timezone) { this.region.timezone = r; is_done_timezone = true } });

        } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
      }
      if(id === 'add' || tag == 'group') { this.add = true; this.lock = false; this.model.is_alive = true; }
      else {
        this.model.id = Number(id);
        console.log('User.detail.vue', 'load item', id);
        try{
          this.add = false;
          this.lock = (tag != 'edit');
          let rs = await Api.Partner_Call('user', 'detail', { id : id })
          this.model = Object.assign({ group: {} }, this.model, rs.body)

          let is_done_country = false;
          codes.country.forEach(r => { if(is_done_country || !this.model.country) { return; } else if(r.value == this.model.country.toUpperCase()) { this.region.country = r; is_done_country = true } });

          let is_done_language = false;
          codes.language.forEach(r => { if(is_done_language || !this.model.language) { return; } else if(r.value == this.model.language.toUpperCase()) { this.region.language = r; is_done_language = true } });

          let is_done_timezone = false;
          codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(r.value == this.model.timezone) { this.region.timezone = r; is_done_timezone = true } });

        } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
      }
    }
  },
  created() { console.log('User_Detail.vue', 'created'); },
  destroyed() { console.log('User_Detail.vue', 'destroyed'); },
  mounted() {
    console.log('User_Detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
</script>
